import { provideBaseWidget } from '@adaptiva/core/widgets';
import { LabelComponent } from '@adaptiva/widgets/label';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
	standalone: false,
	selector: 'ada-authoring-property-label',
	templateUrl: './authoring-property-label.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ['./authoring-property-label.component.scss'],
	providers: [provideBaseWidget(() => AuthoringPropertyLabelComponent)],
})
export class AuthoringPropertyLabelComponent extends LabelComponent implements OnInit {

	@ViewChild('InheritanceDisplay')
	public inheritanceDisplay: ToggleSwitchComponent;

	@Input()
	public inheriting: boolean;

	@Input()
	public inheritingText: string;

	@Input()
	public canInheritWhenRequired: boolean = false;

	@Output()
	public inheritanceChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	public emitInheritanceChange(): void {
		if (!this.inheriting)
			this.inheritanceChange.emit();
	}

}
